<template>
  <div class="instant-search">
    <div class="search-container">
      <div class="input-search-field">
        <input
            type="text"
            :placeholder="placeholder"
            @keyup="keyup"
            v-model="keyword"
            ref="searchInput"
        >
        <img
            src="/assets/images/front/structure/algolia.svg"
            alt="Algolia"
        >
      </div>
      <ul v-if="collection.length">
        <li
            v-for="(item, index) in collection"
            :key="index"
            :class="highlight(index)"
            @click="select"
            @mouseover="mouseOver(index)"
            v-html="htmlLine(item)"
        ></li>
      </ul>
    </div>
    <span
        v-if="showClose"
        class="close-button"
        @click="close"
    >
            <span class="fas fa-times"></span>
        </span>
  </div>
</template>

<script>
import algoliasearch from 'algoliasearch/lite'

export default {
  props: {
    index: {
      type: String,
      default: document.head.querySelector('meta[name="algolia-global-index"]').content,
    },
    hitsPerPage: {
      type: Number,
      default: 5
    },
    placeholder: {
      type: String,
      default: 'SEARCH'
    },
    showClose: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      searchIndex: null,
      keyword: '',
      collection: [],
      selectedIndex: -1,
      lastEnteredKeyword: '',
      selectedItem: null,
    }
  },
  created () {
    let appId = document.head.querySelector('meta[name="algolia-app-id"]').content;
    let searchKey = document.head.querySelector('meta[name="algolia-key"]').content;
    if (!appId || !searchKey) {
      return
    }
    let client = algoliasearch(appId, searchKey);
    this.searchIndex = client.initIndex(this.index);
  },
  mounted () {
    if (!this.searchIndex) {
      return
    }
    window.EventHandler.listen('body-clicked', event => {
      if (this.$el.contains(event.target) || this.selectedItem) {
        return
      }
      this.dismiss()
    })

    window.EventHandler.listen('search-form-focus', opened => {
      if (opened) {
        this.$nextTick(() => this.$refs.searchInput.focus())
      }
    })

    this.$nextTick(() => {
      this.$refs.searchInput.focus()
    })
  },
  destroyed () {
    this.searchIndex = null
    this.keydown = ''
    this.clear()
  },
  methods: {
    highlight (index) {
      return {
        highlighted: this.selectedIndex === index
      }
    },
    htmlLine (item) {
      return item._highlightResult.name.value + '<br />' +
          '<small>' + item._snippetResult.description.value + '</small>'
    },
    fetch () {
      if (!this.searchIndex || !this.keyword) {
        this.collection = []
        return
      }

      this.lastEnteredKeyword = this.keyword

      this.searchIndex.search(this.keyword, {
        hitsPerPage: this.hitsPerPage
      })
          .then(({ hits }) => {
            this.collection = hits
          })
          .catch(error => {
            this.collection = []
            console.error(error)
          })
    },
    keyup (event) {
      switch (event.code) {
        case 'ArrowUp':
          this.arrowUp()
          break
        case 'ArrowDown':
          this.arrowDown()
          break
        case 'Escape':
          this.dismiss()
          break
        case 'Enter':
          this.select(event)
          break
        default:
          this.fetch()
          break
      }
    },
    arrowDown () {
      if (this.selectedIndex === (this.collection.length - 1)) {
        return
      }

      this.selectedIndex++
      this.updateKeyword()
    },
    arrowUp () {
      if ([-1, 0].includes(this.selectedIndex)) {
        this.selectedIndex = -1
        this.resetKeyword()
        return
      }

      this.selectedIndex--
      this.updateKeyword()
    },
    readyToSelect () {
      if (this.selectedIndex === -1) {
        this.collection = []
        return false
      }
      if (!this.selectedItem) {
        this.selectedItem = this.collection[this.selectedIndex]
        this.updateKeyword()
      }
      return true
    },
    dismiss () {
      this.keyword = ''
      this.lastEnteredKeyword = ''
      this.clear()
    },
    clear () {
      this.selectedIndex = -1
      this.collection = []
    },
    resetKeyword () {
      this.keyword = this.lastEnteredKeyword
    },
    mouseOver (index) {
      this.selectedIndex = index
    },
    select (event) {

      if (!this.readyToSelect()) {
        return
      }

      event.preventDefault()

      this.redirect()
    },
    redirect () {
      window.location.href = this.selectedItem.url
    },
    updateKeyword () {
      this.keyword = this.collection[this.selectedIndex].name
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>